import store from "store";
import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax";
import isMobile from '../common/is-mobile.js'
var tl = new TimelineMax();

$(window).on("load resize", function(){
  var h = $(window).height();
  if(isMobile(767)){
    $("#c-loading").css("height", h + "px");
  }
}).trigger("resize");

function linkTransition(e){
  var url = $(this).attr('href');
  var target = $(this).attr('target');
  console.log(url);
  
  if((url.indexOf('#'))){
    e.preventDefault();
    if (url !== '') {
      $('#c-loading-page-2').addClass('is-active');
      setTimeout(function(){
        window.location = url;
      }, 500);
    }
    return false;
  }
}

$('a').on("click", linkTransition);

 $('a[target="_blank"]').off("click");
 $('a[href^="tel:"]').off("click");
 $('a[href^="mailto:"]').off("click");
 
//トップページでアニメーション再生するか判断
var isTopPage = -1 < $.inArray(location.pathname, ["/", "/recruit/fresh_career.html"]);
var pathname = function () {
  return location.pathname == '/recruit/fresh_career.html' ? '/' : location.pathname
}

if(isTopPage) {
  // ==================================================
  // 外部からこのサイトを訪問したユーザーには必ずアニメーションを見せる
  // いちどアニメーションを見せたらサイト内部を回遊している間はアニメーションを見せない
  // ※トップページでリロードした場合は、アニメーションを見せる
  // ==================================================
  var fromOutside = ! document.referrer.match(location.host);

  if (fromOutside) {
    store.set('referrer', location.pathname)
  }

  if(pathname() == store.get('referrer')) {
    $('body').addClass('store');
    $('body').addClass('is-static');
    // ページのロードが終わった後の処理
    $(window).one('load' ,function(){
      $('#c-loading').delay(1200).fadeOut(1000); //ローディング画面をフェードアウトさせることでメインコンテンツを表示
      $('#c-loading img').delay(500).fadeOut(1000); //ローディング画面をフェードアウトさせることでメインコンテンツを表示
      $('body').delay(1200).queue(function() {
        $(this).removeClass('is-static').dequeue();
      });
    });
  } else {
    $('#c-loading').delay(1200).fadeOut(1000); //ローディング画面をフェードアウトさせることでメインコンテンツを表示
    $('#c-loading img').delay(500).fadeOut(1000); //ローディング画面をフェードアウトさせることでメインコンテンツを表示
    $('body').removeClass('is-static');
    console.log('aaaa');
  }
} else {
  $(window).one('load' ,function(){
    tl.to(".c-loading-page__bg", 0.5,{ transform: 'scale(0,1)', onComplete: function(){
      $('#c-loading-page').hide();
    } })
  });
}
store.set('referrer', pathname())
console.log(isTopPage);
